import { render, staticRenderFns } from "./HeaderSponsor.vue?vue&type=template&id=6dd6cf8f"
import script from "./HeaderSponsor.vue?vue&type=script&lang=js"
export * from "./HeaderSponsor.vue?vue&type=script&lang=js"
import style0 from "./HeaderSponsor.vue?vue&type=style&index=0&id=6dd6cf8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports